export class PortalRolesRequest {
 
    portals: any[];

}